module.exports = __webpack_public_path__ + "locations-ic.svg?2e7473483e34a7b7690c95dc8708aace";